class ImageZoom {
  constructor(element) {
    this.element = element;
    this.zoomer = element.querySelector('.js-image-zoom__zoomer');
    this.image = element.querySelector('img');
    this.zoomedImageSrc = this.image.dataset.zoom;
    this.originalBackgroundPosition = '0% 0%';
    this.touchX = 0;
    this.touchY = 0;
    this.isTouching = false;

    this.initImageZoom();
    this.addEventListeners();
  }

  initImageZoom() {
    this.image.style.userSelect = 'none';
    this.checkImageLoading();
  }

  checkImageLoading() {
    if (this.image.complete) {
      this.initializeZoom();
    } else {
      this.image.addEventListener('load', () => {
        this.initializeZoom();
      });
    }
  }

  setZoomImageElement() {
    // check if element exists
    let zoomElement = this.element.querySelector('.js-image-zoom__zoom-image');
    if (!zoomElement) {
      // create element
      zoomElement = document.createElement('div');
      zoomElement.classList.add('js-image-zoom__zoom-image');
      // update background image, position
      zoomElement.style.backgroundImage = `url(${this.zoomedImageSrc})`;
      zoomElement.style.backgroundPosition = this.originalBackgroundPosition;

      this.zoomer.appendChild(zoomElement);
    } else {
      // update element
      zoomElement.style.backgroundImage = `url(${this.zoomedImageSrc})`;
      zoomElement.style.backgroundPosition = this.originalBackgroundPosition;
    }

    this.zoomerImage = zoomElement;
  }

  initializeZoom() {
    this.zoomerWidth = this.zoomer.offsetWidth;
    this.zoomerHeight = this.zoomer.offsetHeight;
    if (window.innerWidth >= 750) {
      this.zoomer.style.backgroundImage = '';
      this.setZoomImageElement();
    } else {
      this.zoomer.style.backgroundImage = `url(${this.zoomedImageSrc})`;
      this.originalBackgroundPosition = this.zoomer.style.backgroundPosition;
    }
  }

  addEventListeners() {
    this.zoomer.addEventListener('mousemove', (e) => {
      this.handleMouseMove(e);
    });

    this.zoomer.addEventListener('mouseleave', () => {
      this.handleMouseLeave();
    });

    this.zoomer.addEventListener('touchmove', (e) => {
      this.handleTouchMove(e);
    });

    this.zoomer.addEventListener('touchend', () => {
      this.handleTouchEnd();
    });

    this.image.addEventListener('touchstart', (e) => {
      e.preventDefault();
    });

    window.addEventListener('resize', () => {
      this.initializeZoom();
    });
  }

  handleMouseMove(e) {
    this.element.classList.add('active');
    requestAnimationFrame(() => this.zoom(e));
  }

  handleMouseLeave() {
    this.element.classList.remove('active');
    this.resetImage();
  }

  handleTouchMove(e) {
    if (!this.isTouching) {
      this.element.classList.add('active');
      this.isTouching = true;
    }
    this.trackTouchPosition(e);
    requestAnimationFrame(() => this.touchZoom());
  }

  handleTouchEnd() {
    this.isTouching = false;
    this.element.classList.remove('active');
    this.resetImage();
  }

  zoom(e) {
    let offsetX, offsetY, x, y;

    if (e.type === 'mousemove') {
      offsetX = e.clientX - this.element.getBoundingClientRect().left;
      offsetY = e.clientY - this.element.getBoundingClientRect().top;
    } else if (e.type === 'touchmove') {
      offsetX = this.touchX;
      offsetY = this.touchY;
    }

    if (this.zoomerWidth && this.zoomerHeight) {
      x = (offsetX / this.zoomerWidth) * 100;
      y = (offsetY / this.zoomerHeight) * 100;
      if (window.innerWidth >= 750) {
        this.zoomerImage.style.backgroundPosition = `${x}% ${y}%`;
      } else {
        this.zoomer.style.backgroundPosition = `${x}% ${y}%`;
      }
    }
  }

  trackTouchPosition(e) {
    if (e.touches.length === 1) {
      this.touchX = e.touches[0].clientX - this.element.getBoundingClientRect().left;
      this.touchY = e.touches[0].clientY - this.element.getBoundingClientRect().top;
    }
  }

  touchZoom() {
    this.zoom({ type: 'touchmove' });
  }

  resetImage() {
    if (window.innerWidth >= 750) {
      this.zoomer.style.backgroundPosition = this.originalBackgroundPosition;
    } else {
      if (this.zoomerImage) {
        this.zoomerImage.style.backgroundPosition = this.originalBackgroundPosition;
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const imageZoomElements = document.querySelectorAll('.js-image-zoom');
  imageZoomElements.forEach((element) => {
    new ImageZoom(element);
  });
});
